export const testIds = {
  partnerScoreContainer: 'ces-partner-score-data-availability-container',
  partnerScoreTopWidget: 'ces-partner-score-data-availability-top-widget',
  partnerScoreHeader: 'ces-partner-score-data-availability-header',
  partnerScoreToggleButton: 'ces-partner-score-data-availability-toggle-button',
  partnerScoreTableContainer: 'ces-partner-score-data-availability-table-container',
  partnerScoreLoadingSpinner: 'ces-partner-score-data-availability-loading-spinner',
  partnerScoreNoData: 'ces-partner-score-data-availability-no-data',
  partnerScoreTableWrapper: 'ces-partner-score-data-availability-table-wrapper',
  partnerScoreTable: 'ces-partner-score-data-availability-table',
  partnerScoreTableHeader: 'ces-partner-score-data-availability-table-header',
  partnerScoreTableBody: 'ces-ces-partner-score-data-availability-table-body',
  partnerScoreTableRow: (index: number) => `ces-partner-score-data-availability-table-row-${index}`,
  partnerScoreTooltip: 'ces-partner-score-data-availability-tooltip',
};
